import { resetRem, isIP } from '@/utils/index';
import Browser from './browser';
import store from '@/store/index';

import fullSceenTips from '@/packages/fullSceenTips/index.js';
// import scrollfullSceen from '@/packages/scrollfullSceen/index.js';
import HotGamePush from '@/packages/hotGamePush/index.js';

const browser = new Browser();

let scrollfullSceenInstance = null;

export function init() {
	window.addEventListener('resize', () => {
		uiInit();
		var doc = window.document;
		var docEl = doc.documentElement;
		var width = docEl.getBoundingClientRect().width,
			height = docEl.getBoundingClientRect().height,
			areaSize = width * height;
		store.dispatch('setAreaSize', areaSize);
		setSizeAdapter();
	});

	window.onorientationchange = function() {
		window.setTimeout(function() {
			checkBrowserSupport();
			setIfmSize();
			iPadAdapter();
			setScreenDirection();
			if (browser.getDirection() == 'vertical') {
				if (scrollfullSceenInstance != null) {
					scrollfullSceenInstance.close();
					scrollfullSceenInstance = null;
				}
			}
			resetRem();
			hotGamePushAdapter();
			setSizeAdapter();
			if (window.orientation == 180 || window.orientation == 0) {
				window.___betterScrollIsVertical = true;
			} else {
				window.___betterScrollIsVertical = false;
			}
		}, 350);
	};

	window.addEventListener('scroll', function() {
		if (browser.getDirection() == 'horizontal') {
			// if (browser.isSupportBrowser()) {
			// 	console.error(
			// 		'滚动中：' +
			// 			document.documentElement.scrollHeight +
			// 			'-' +
			// 			document.documentElement.clientHeight +
			// 			'-' +
			// 			window.innerHeight
			// 	);
			// if (window.innerHeight == document.documentElement.clientHeight && document.documentElement.scrollHeight > document.documentElement.clientHeight) {
			// 	setIfmSize();
			// 	if (scrollfullSceenInstance != null) {
			// 		console.error('移除222');
			// 		scrollfullSceenInstance.close();
			// 		scrollfullSceenInstance = null;
			// 	}
			// }
			//}
		} else {
			document.body.scrollTop = -1;
		}
	});
	uiInit();
	setCrossDomain();
	setSizeAdapter();
}

/**通过长宽比判断方向 */
function setSizeAdapter() {
	var doc = window.document;
	var docEl = doc.documentElement;
	var width = docEl.getBoundingClientRect().width;
	var height = docEl.getBoundingClientRect().height;
	store.dispatch('setSizeDirection', height > width ? 'vertical' : 'horizontal');
}

/**热门游戏推荐适配 */
function hotGamePushAdapter() {
	if (window._hotGamePush && window._hotGamePushID) {
		window._hotGamePush.close();
		window._hotGamePush = HotGamePush.service({
			gameID: window._hotGamePushID,
			vertical: browser.getDirection() == 'vertical' ? true : false
		});
	}
}

//设置跨域
function setCrossDomain() {
	const l_host = window.location.host;
	if (l_host.indexOf('.') != -1 && !isIP(l_host)) {
		const subDomain = l_host.substring(l_host.indexOf('.') + 1, l_host.length);
		if (subDomain && subDomain.length > 0) {
			try {
				window.document.domain = subDomain;
			} catch (e) {
				console.warn("domain:"+e);
			}
		}
	}
}

//Ipad适配
export function iPadAdapter() {
	if (browser.isIPad()) {
		if (browser.getDirection() == 'horizontal') {
			store.dispatch('setIpadMode', 'horizontal');
		} else {
			store.dispatch('setIpadMode', 'vertical');
		}
	} else {
		if (browser.isMobile()) {
			store.dispatch('setIpadMode', 'none');
		} else {
			/**屏幕长宽比 1500x720 1200x720之间，宽大于1500，左右黑边，宽小于1200，上下黑边，只判断PC 仅限于3D游戏 **/
			const game3dID = [ 1301, 1302, 1303 ];
			const currentGameID = store.state.app.currentGameID;
			if (currentGameID && game3dID.includes(currentGameID)) {
				const w = window.innerWidth;
				const h = window.innerHeight;
				const ratio = w / h;
				const min = 1200 / 720;
				const max = 1500 / 720;
				if (ratio < min || ratio > max) {
					if (ratio < min) {
						store.dispatch('setIpadMode', 'horizontal');
					} else {
						//超宽的处理
						store.dispatch('setIpadMode', 'horizontalSuperWide');
					}
				} else {
					store.dispatch('setIpadMode', 'none');
				}
			} else {
				store.dispatch('setIpadMode', 'none');
			}
		}
	}
}

function uiInit() {
	resetRem();
	checkBrowserSupport();
	setIfmSize();
	iPadAdapter();
	setScreenDirection();
}

//保存屏幕方向
function setScreenDirection() {
	const direction = browser.getDirection();
	store.dispatch('setScreenDirection', direction || 'horizontal');
}

export function setIfmSize() {
	//console.error(document.documentElement.clientHeight + '--' + window.innerHeight);
	store.dispatch('setIfmHeight', window.innerHeight);
	setTimeout(function() {
		window.scrollTo(0, 1);
	}, 0);
}

//检测是否是支持的浏览器并提示
const checkBrowserSupport = () => {
	if (browser.isShowTips() && !window.__shoWfullSceenTips) {
		if (window.__fullSceenTips) {
			window.__fullSceenTips.close();
		}
		window.__fullSceenTips = fullSceenTips.service({
			html:
				'<div style="font-size: .15rem;color:#ffffff;text-align: center;">为了获得更好的游戏体验，请使用<font color="red">safari浏览器</font>进行游戏</div>'
		});
		window.__shoWfullSceenTips = true;
	}
	// if (browser.isSupportBrowser() && browser.getDirection() == 'horizontal') {
	// 	if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
	// 		if (scrollfullSceenInstance == null) {
	// 			scrollfullSceenInstance = scrollfullSceen.service();
	// 		}
	// 	}
	// }
};
